import styled from "styled-components";

export const DatePickerStyles = styled.div`
  .error {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.error} !important;
  }

  .errorMessage {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.caption.c1.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b1.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.error};
    margin-top: ${({ theme }) => theme.spacing[4]};
    height: 24px;
  }

  .input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: ${({ theme }) => theme.radius[4]};
    padding: ${({ theme }) => theme.spacing[8]};
    cursor: pointer;
    user-select: none;

    .valueContainer {
      display: flex;
      align-items: center;

      .iconContainer {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: ${({ theme }) => theme.spacing[8]};
      }

      .value {
        font-style: normal;
        font-weight: ${({ theme }) => theme.typography.title.t2.weight};
        font-size: ${({ theme }) => theme.typography.body.b2.size};
        line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
        color: ${({ theme }) => theme.colors.semantic.text.strong};
      }

      .placeholder {
        font-style: normal;
        font-weight: ${({ theme }) => theme.typography.body.b2.weight};
        font-size: ${({ theme }) => theme.typography.body.b2.size};
        line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
        color: ${({ theme }) => theme.colors.semantic.text.placeholder};
      }
    }

    .arrowContainer {
      display: flex;
      align-items: center;
      justify-content: center;
      transform: rotate(180deg);
    }
  }

  .selected {
    background: ${({ theme }) => theme.colors.semantic.container.white} !important;
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default} !important;
  }

  .input:hover {
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.hover};
  }

  .disabledInput {
    border: 1px solid ${({ theme }) => theme.colors.primary[300]} !important;
    background: ${({ theme }) => theme.colors.semantic.accent.disabled} !important;
    pointer-events: none;
    opacity: 0.7;
  }

  /* picker style */
  .react-datepicker {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    border: none;
    border-radius: ${({ theme }) => theme.radius[12]};
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }

  .react-datepicker-popper {
    z-index: 10;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__month-container {
    padding: ${({ theme }) => theme.spacing[8]};
  }

  .react-datepicker__header {
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border-bottom: none;
    padding-top: ${({ theme }) => theme.spacing[8]};
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
  }

  .react-datepicker__navigation {
    top: 14px;
    width: 28px;
    height: 28px;
    border: none;
  }

  .react-datepicker__navigation--previous {
    left: ${({ theme }) => theme.spacing[12]};
  }

  .react-datepicker__navigation--next {
    right: ${({ theme }) => theme.spacing[12]};
  }

  .react-datepicker__navigation-icon::before {
    border-color: ${({ theme }) => theme.colors.semantic.text.strong};
    border-width: 2px 2px 0 0;
    width: 8px;
    height: 8px;
  }

  .react-datepicker__day-name {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    width: 36px;
    line-height: 36px;
    margin: 2px;
  }

  .react-datepicker__day {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 50%;
    margin: 2px;
    transition: background-color 0.15s ease;

    &:hover {
      border-radius: 50%;
      background-color: ${({ theme }) => theme.colors.accent[50]};
    }
  }

  .react-datepicker__day--today,
  .react-datepicker__month-text--today,
  .react-datepicker__quarter-text--today,
  .react-datepicker__year-text--today {
    font-weight: normal !important;
    background-color: ${({ theme }) => theme.colors.accent[200]};
    color: ${({ theme }) => theme.colors.semantic.container.white};
    border-radius: 50%;

    &:hover {
      background-color: ${({ theme }) => theme.colors.accent[200]};
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    border: 1.5px solid ${({ theme }) => theme.colors.semantic.text.strong};
    border-radius: 50%;

    &:hover {
      background-color: ${({ theme }) => theme.colors.accent[50]};
      border-radius: 50%;
    }
  }

  .react-datepicker__day--keyboard-selected {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.semantic.text.strong};

    &:hover {
      background-color: ${({ theme }) => theme.colors.accent[50]};
      border-radius: 50%;
    }
  }

  .react-datepicker__day--outside-month {
    color: ${({ theme }) => theme.colors.semantic.text.placeholder};
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b3.weight} !important;
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected {
    background-color: ${({ theme }) => theme.colors.semantic.text.strong};
    color: ${({ theme }) => theme.colors.semantic.accent.onAccent};
    font-weight: normal;
  }

  .react-datepicker__header--time {
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .react-datepicker__time-container .react-datepicker__time {
    height: 100%;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box {
    height: 100%;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled {
    color: ${({ theme }) => theme.colors.primary[200]} !important;
  }

  .react-datepicker-wrapper {
    display: flex;
  }

  .react-datepicker__input-container {
    width: 100%;
  }
`;
